// extracted by mini-css-extract-plugin
export var accordeoncontainer = "styles-module--accordeoncontainer--fw33q";
export var futureaccordeoncontainer = "styles-module--futureaccordeoncontainer---Osg4";
export var xponentaccordeoncontainer = "styles-module--xponentaccordeoncontainer--TavOF";